import React, { useState, useEffect } from 'react';
import Popup from 'antd-mobile/es/components/popup';
import { H5Button } from './components/H5Button';
import { H5Form } from './components/H5Form';
import styles from './pc.module.scss';
import { useTranslation } from './LangContext';

export const H5Modal = () => {
  const [visible, setVisible] = useState(false);

  const { t } = useTranslation();

  // 处理页面不让滚动的效果
  useEffect(() => {
    const { body } = document;

    if (visible) {
      body.style.overflow = 'hidden';
    } else {
      body.style.setProperty('overflow', '');
    }
  }, [visible]);

  return (
    <div className={styles.H5modalWrap}>
      <H5Button title={t('applyBtnTitle')} onClick={() => setVisible(true)} />
      <Popup
        visible={visible}
        bodyStyle={{
          height: 'calc(100% - 8.75rem)',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
        }}
        style={{ '--z-index': '100000' }}
        onMaskClick={() => setVisible(false)}
        forceRender
        destroyOnClose
        closeOnMaskClick
      >
        {visible && (
          <H5Form
            onClose={() => {
              setVisible(false);
            }}
          />
        )}
      </Popup>
    </div>
  );
};
